import { effect, inject, Injectable } from '@angular/core';
import { AuthService } from '@sankarah/commo-shared-data-access';
import * as Sentry from '@sentry/angular';

/** Sentry には user id だけ載せる（メール・表示名は送らない） */
@Injectable({ providedIn: 'root' })
export class SentryUserService {
  private readonly authService = inject(AuthService);

  constructor() {
    effect(() => {
      const user = this.authService.user();
      Sentry.setUser(user?.id ? { id: user.id } : null);
    });
  }
}
